import axios from "axios";
import {ConcurrencyManager} from "axios-concurrency";
import axiosRetry from "axios-retry";
const baseUrl = process.env.REACT_APP_CARTO_PIA_URL;

const axiosCartoLayerInstance = axios.create({
  baseURL: baseUrl,
})
axiosRetry(axiosCartoLayerInstance, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 1000;
  },
  retryCondition: (error) => {
    return (
      axiosRetry.isNetworkError(error) ||
      axiosRetry.isRetryableError(error) ||
      error.response?.status >= 500
    );
  },
});

ConcurrencyManager(axiosCartoLayerInstance, 4);
export default axiosCartoLayerInstance
